var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { flat: "", small: "", color: "primary" },
              on: {
                click: function($event) {
                  return _vm.$emit("clone", _vm.node)
                }
              }
            },
            [_c("v-icon", [_vm._v("add")]), _vm._v(" clone")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { flat: "", small: "", color: "primary" },
              on: {
                click: function($event) {
                  return _vm.$emit("edit", _vm.node)
                }
              }
            },
            [_c("v-icon", [_vm._v("edit")]), _vm._v(" edit")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { flat: "", small: "", color: "primary" },
              on: {
                click: function($event) {
                  return _vm.$emit("delete", _vm.node)
                }
              }
            },
            [_c("v-icon", [_vm._v("delete")]), _vm._v(" delete")],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-card-title", { attrs: { "primary-title": "" } }, [
        _c("h2", [
          _vm._v('Channel collection "' + _vm._s(_vm.node.label) + '"')
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "node-id" }, [
          _vm._v("#" + _vm._s(_vm.node.id))
        ])
      ]),
      _vm._v(" "),
      _c("v-card-text", [
        _c(
          "div",
          [
            _c("v-card-title", [_c("h4", [_vm._v("Global parameters")])]),
            _vm._v(" "),
            _c("table", { staticClass: "display-node" }, [
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v("Network")]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.nodeMapping.network[_vm.node.data.network].label
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Location")]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.nodeMapping.location[_vm.node.data.location].label
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Channel flags")]),
                  _c("td", [_vm._v(_vm._s(_vm.node.data.flags.join(", ")))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Format")]),
                  _c("td", [_vm._v(_vm._s(_vm.node.data.format))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Open date")]),
                  _c("td", [_vm._v(_vm._s(_vm.node.data.open))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Close date")]),
                  _c("td", [_vm._v(_vm._s(_vm.node.data.close))])
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("v-card-title", [_c("h4", [_vm._v("Devices")])]),
            _vm._v(" "),
            _c("table", { staticClass: "display-node" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Device type")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Manufacturer")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Model")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Serial number")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.devicesTableStruct, function(row) {
                  return _c(
                    "tr",
                    _vm._l(row, function(value) {
                      return _c("td", [_vm._v(_vm._s(value))])
                    }),
                    0
                  )
                }),
                0
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("v-card-title", [_c("h4", [_vm._v("Channels")])]),
            _vm._v(" "),
            _c("table", { staticClass: "display-node" }, [
              _c(
                "thead",
                _vm._l(_vm.channelsTableStruct.header, function(header) {
                  return _c(
                    "tr",
                    _vm._l(header, function(h) {
                      return _c("th", _vm._b({}, "th", h.attrs, false), [
                        _vm._v(_vm._s(h.text))
                      ])
                    }),
                    0
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.channelsTableStruct.rows, function(row) {
                  return _c(
                    "tr",
                    [
                      _vm._l(row, function(col) {
                        return [
                          col.list
                            ? _c("td", [
                                _c(
                                  "ul",
                                  _vm._l(col.items, function(item) {
                                    return _c("li", [_vm._v(_vm._s(item))])
                                  }),
                                  0
                                )
                              ])
                            : _c("td", [_vm._v(_vm._s(col.text))])
                        ]
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("v-card-title", [_c("h4", [_vm._v("Plot response")])]),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: { disabled: _vm.loading || _vm.plotValues != null },
                on: { click: _vm.handlePlotResponseBtnClick }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.loading ? "Loading..." : "Plot") +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "plot_response--gain" }),
            _vm._v(" "),
            _c("div", { staticClass: "plot_response--phase" })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2118e7e2", { render: render, staticRenderFns: staticRenderFns })
  }
}